/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './ie.support';

import angular from 'angular';
import ngMaterial from 'angular-material';
import ngMessages from 'angular-messages';
import ngMdIcons from 'angular-material-icons';
import ngCookies from 'angular-cookies';
import angularSocialshare from 'angular-socialshare';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-local';
import 'angular-translate-storage-cookie';
import 'angular-translate-handler-log';
import 'angular-translate-interpolation-messageformat';
import 'md-color-picker';
import mdPickers from 'mdPickers';
import ngSanitize from 'angular-sanitize';
import vAccordion from 'v-accordion';
import 'angular-material-expansion-panel';
import ngAnimate from 'angular-animate';
import 'angular-websocket';
import uiRouter from 'angular-ui-router';
import angularJwt from 'angular-jwt';
import 'angular-drag-and-drop-lists';
import mdDataTable from 'angular-material-data-table';
import fixedTableHeader from 'angular-fixed-table-header';
import ngTouch from 'angular-touch';
import 'angular-carousel';
import 'clipboard';
import 'ngclipboard';
import 'react';
import 'react-dom';
import 'material-ui';
import 'react-schema-form';
import react from 'ngreact';
import '@flowjs/ng-flow/dist/ng-flow-standalone.min';
import 'angular-breadcrumb';
import 'angular-ui-ace';
import 'ngmap';
import 'flot/lib/jquery.colorhelpers';
import 'flot/src/jquery.flot';
import 'flot/src/plugins/jquery.flot.time';
import 'flot/src/plugins/jquery.flot.selection';
import 'flot/src/plugins/jquery.flot.pie';
import 'flot/src/plugins/jquery.flot.crosshair';
import 'flot/src/plugins/jquery.flot.stack';
// import 'flot.curvedliangular.js:15567 md-grid-listnes/curvedLines';

import tektelicUtilsFullscreen from './common/utils.fullscreen';
import tektelicLocales from './locale/locale.constant';
import tektelicTypes from './common/types.constant';
import tektelicUtils from './common/utils.service';
import tektelicToast from './services/toast';
import tektelicMenu from './services/menu.service';
import tektelicImportExport from './import-export';
import tektelicApiLogin from './api/login.service';
import tektelicApiUser from './api/user.service';
import tektelicApiAdmin from './api/admin.service';
import tektelicApiProvider from './api/provider.service';
import tektelicApiGatewayGroup from './api/gateway-group.service';
import tektelicApiGateway from './api/gateway.service';
import tektelicApiGatewayCommand from './api/gateway-command.service';
import tektelicApiCustomer from './api/customer.service';
import tektelicApiGeo from './api/geo.service';
import tektelicApiDeviceGroup from './api/device-group.service';
import tektelicApiSubCustomer from './api/subcustomer.service';
import tektelicApiDevice from './api/device.service';
import tektelicApiCredentials from './api/credentials.service';
import tektelicApiEntity from './api/entity.service';
import tektelicApiConfiguration from './api/configuration.service';
import tektelicApiEvent from './api/event.service';
import tektelicApiNetworkSettings from './api/network-settings.service';
import tektelicApiApiLimits from './api/api-limits.service';
import tektelicApiProviderSubscription from './api/provider-subscription.service';
import tektelicApiCustomerSubscription from './api/customer-subscription.service';
import tektelicApiWsSubscription from './api/ws-subscription.service';
import tektelicApiDeviceModel from './api/device-model.service';
import tektelicApiGatewayModel from './api/gateway-model.service';
import tektelicApiTime from './api/time.service';
import tektelicApiFileTransfer from './api/file-transfer.service';

import tektelicComponents from './components';
import tektelicTable from './table';
import tektelicDialog from './dialog';
import tektelicConfiguration from './configuration';
import tektelicAlarmRules from './alarm-rule';
import tektelicEvent from './event';

import tektelicLogin from './login';
import tektelicHome from './layout';
import tektelicHomeLinks from './home';
import tektelicProfile from './profile';
import tektelicAdmin from './admin';
import tektelicUser from './user';
import tektelicProvider from './provider';
import tektelicGatewayGroup from './gateway-group';
import tektelicGateway from './gateway';
import tektelicCustomer from './customer';
import tektelicDeviceGroup from './device-group';
import tektelicSubCustomer from './subcustomer';
import tektelicDevice from './device';
import tektelicNetworkSettings from './network-settings';
import tektelicResolverConfiguration from './resolver-configuration';
import tektelicAlgorithmConfiguration from './algorithm-configuration';
import tektelicApiLimits from './api-limits';
import tektelicProviderSubscription from './provider/subscription';
import tektelicCustomerSubscription from './customer/subscription';
import tektelicGatewayModel from './gateway-model';
import tektelicAlarms from './alarm';
import tektelicGeoLocation from './geo-location';
import tektelicHardwareEntities from './hardware-entities';

import 'typeface-roboto';
import 'font-awesome/css/font-awesome.min.css';
import 'angular-material/angular-material.min.css';
import 'angular-material-icons/angular-material-icons.css';
import 'angular-gridster/dist/angular-gridster.min.css';
import 'v-accordion/dist/v-accordion.min.css';
import 'angular-material-expansion-panel/dist/md-expansion-panel.min.css';
import 'md-color-picker/dist/mdColorPicker.min.css';
import 'mdPickers/dist/mdPickers.min.css';
import 'angular-hotkeys/build/hotkeys.min.css';
import 'angular-carousel/dist/angular-carousel.min.css';
import 'angular-material-data-table/dist/md-data-table.min.css';
import '../scss/main.scss';

import AppConfig from './app.config';
import GlobalInterceptor from './global-interceptor.service';
import AppRun from './app.run';

angular.module('tektelic', [
    ngMaterial,
    ngMessages,
    ngMdIcons,
    ngCookies,
    angularSocialshare,
    'pascalprecht.translate',
    'mdColorPicker',
    mdPickers,
    ngSanitize,
    'ncy-angular-breadcrumb',
    vAccordion,
    'material.components.expansionPanels',
    ngAnimate,
    'ngWebSocket',
    angularJwt,
    'dndLists',
    mdDataTable,
    fixedTableHeader,
    ngTouch,
    'angular-carousel',
    'ngclipboard',
    react.name,
    'flow',
    'ui.ace',
    'ngMap',
    uiRouter,
    tektelicUtilsFullscreen,
    tektelicLocales,
    tektelicTypes,
    tektelicUtils,
    tektelicToast,
    tektelicMenu,
    tektelicImportExport,
    tektelicApiLogin,
    tektelicApiUser,
    tektelicApiAdmin,
    tektelicApiProvider,
    tektelicApiGatewayGroup,
    tektelicApiGateway,
    tektelicApiGatewayCommand,
    tektelicApiGeo,
    tektelicApiCustomer,
    tektelicApiDeviceGroup,
    tektelicApiSubCustomer,
    tektelicApiDevice,
    tektelicApiCredentials,
    tektelicApiEntity,
    tektelicApiConfiguration,
    tektelicApiEvent,
    tektelicApiNetworkSettings,
    tektelicApiApiLimits,
    tektelicApiProviderSubscription,
    tektelicApiCustomerSubscription,
    tektelicApiWsSubscription,
    tektelicApiDeviceModel,
    tektelicApiGatewayModel,
    tektelicApiTime,
    tektelicApiFileTransfer,
    tektelicComponents,
    tektelicTable,
    tektelicDialog,
    tektelicConfiguration,
    tektelicAlarmRules,
    tektelicEvent,
    tektelicLogin,
    tektelicHome,
    tektelicHomeLinks,
    tektelicProfile,
    tektelicAdmin,
    tektelicUser,
    tektelicProvider,
    tektelicProviderSubscription,
    tektelicGatewayGroup,
    tektelicGateway,
    tektelicCustomer,
    tektelicCustomerSubscription,
    tektelicDeviceGroup,
    tektelicSubCustomer,
    tektelicDevice,
    tektelicNetworkSettings,
    tektelicResolverConfiguration,
    tektelicAlgorithmConfiguration,
    tektelicApiLimits,
    tektelicGatewayModel,
    tektelicAlarms,
    tektelicGeoLocation,
    tektelicHardwareEntities])
    .config(AppConfig)
    .factory('globalInterceptor', GlobalInterceptor)
    .run(AppRun);



// WEBPACK FOOTER //
// ./src/app/app.js